import request from '@/utils/request'
import { getToken } from '../../utils/auth'

// 首页人员年龄分布
export function queryelderlycountbyage () {
  return request({ url: '/queryelderlycountbyage', method: 'post', params: { token: getToken() } })
}

// 查询数量统计
export function queryelderlydataview () {
  return request({ url: '/queryelderlydataview', method: 'post', params: { token: getToken() } })
}

// 查询机构服务对象人数统计
export function queryelderlycount () {
  return request({ url: '/queryelderlycount', method: 'post', params: { token: getToken() } })
}

// 查询机构床位
export function queryorgbedcount () {
  return request({ url: '/queryorgbedcount', method: 'post', params: { token: getToken() } })
}

// 获取设备位置
export function querypersonlocation (data) {
  return request({ url: '/personlocation/query', method: 'post', params: { token: getToken() }, data })
}



// WEBPACK FOOTER //
// ./src/api/yanglaoyuan/dataScreen.js